<div class="space-y-8 pb-12">
    <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
            <h1 class="text-4xl font-bold tracking-tight text-[color:var(--foreground)]">Create Property</h1>
            <p class="mt-2 text-sm text-[color:var(--muted-foreground)]">Build the unit record, offer assets, media, and pricing in one flow.</p>
        </div>
        <div class="flex flex-wrap items-center gap-3">
            <button *ngIf="isDevHost" type="button" (click)="fillDummyData()" class="inline-flex items-center gap-2 rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] px-4 py-2 font-semibold text-[color:var(--foreground)] transition-colors hover:bg-[color:var(--hover)]">
                <lucide-icon name="sparkles" class="h-4 w-4"></lucide-icon>
                Fill Dummy Data
            </button>
            <button
                *ngIf="hasSavedDraft"
                type="button"
                [disabled]="saving"
                (click)="clearSavedDraft()"
                class="inline-flex items-center gap-2 rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] px-4 py-2 font-semibold text-[color:var(--destructive)] transition-colors hover:bg-[color:var(--hover)] disabled:opacity-60"
            >
                <lucide-icon name="trash-2" class="h-4 w-4"></lucide-icon>
                Clear Draft
            </button>
            <a routerLink="/developer/properties" queryParamsHandling="preserve" class="inline-flex items-center gap-2 rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] px-4 py-2 font-semibold text-[color:var(--foreground)] transition-colors hover:bg-[color:var(--hover)]">
                <lucide-icon name="arrow-left" class="h-4 w-4"></lucide-icon>
                Back to Properties
            </a>
        </div>
    </div>

    <app-property-create-wizard [vm]="view"></app-property-create-wizard>

    <div *ngIf="completed" class="rounded-2xl border border-green-500/30 bg-green-500/10 p-6">
        <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div class="flex items-center gap-3">
                <div class="rounded-full bg-green-500/30 p-2">
                    <lucide-icon name="check" class="h-5 w-5 text-green-700"></lucide-icon>
                </div>
                <div>
                    <p class="text-lg font-semibold text-[color:var(--foreground)]">Property created</p>
                    <p class="text-sm text-[color:var(--muted-foreground)]">All steps completed. You can view it under Properties.</p>
                </div>
            </div>
            <div class="flex flex-wrap gap-3">
                <button type="button" (click)="startOver()" class="rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] px-4 py-2 font-semibold text-[color:var(--foreground)] transition-colors hover:bg-[color:var(--hover)]">Create another</button>
                <button type="button" (click)="goToProperties()" class="rounded-xl bg-[color:var(--primary)] px-4 py-2 font-semibold text-[color:var(--primary-foreground)] transition-colors hover:bg-[color:var(--primary-hover)]">Go to properties</button>
            </div>
        </div>
    </div>
</div>
